<template>
    <span v-if="getSlaHealthPercent">
        {{ getSlaHealthPercent }}%
        <span
            class="slaHealthPercentChangesCell"
            :class="getSLAClass"
        > {{ getSlaHealthPercentChanges }}
        </span>
    </span>
</template>

<script lang="ts">

export default {
    props: ['params'],
    computed: {
        getSlaHealthPercent() {
            if (this.params.value) {
                return  Math.round(this.params.value);
            }
            return '';
        },
        getSlaHealthPercentChanges() {
            const rowData = this.params.data; // Access the entire row's data
            if (rowData?.slaHealthPercentChanges) {
                return  (rowData.slaHealthPercentChanges > 0 ? ' ↑ ' : ' ↓ ') +  `${Math.round(rowData.slaHealthPercentChanges)}%`;
            }
            return '';
        },
        getSLAClass() {
            const rowData = this.params.data; // Access the entire row's data
            if (rowData?.slaHealthPercentChanges && rowData.slaHealthPercentChanges < 0) {
                return 'is-neg';
            }
            return 'is-pos';
        }
    }
};
</script>

<style lang="scss">

.slaHealthPercentChangesCell.is-pos { color: var(--color-status-positive); }
.slaHealthPercentChangesCell.is-neg { color: var(--color-status-negative); }
.slaHealthPercentChangesCell.is-zero { color: var(--color-status-neutral); }

</style>